import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';

import { renderableType } from '../proptypes/prop-types';
import {MenuItem} from './menuItem';
import { Divider } from '../divider';
import './defaultMegaMenuRenderer.scss';

const containerClassName = 'megaMenu__container';
const categoryClassName = 'megaMenu__category';
const categoryTitleClassName = 'megaMenu__categoryTitle';
const groupClassName = 'megaMenu__group';
const labelIconClassName = 'megaMenu__labelIcon';


/** The default renderer for mega menus */
export const DefaultMegaMenuRenderer = ({ items }) => (
  <div className={containerClassName}>
    {items.map(item => (
      <div key={item.category} className={categoryClassName}>
        <div className={categoryTitleClassName}>{item.category}</div>
        <Divider />
        <div className={groupClassName}>
          {item.subItems.map(subItem => (
            <MenuItem
              key={`menuitem-${subItem.label.replace(/\s+/g, '-')}`}
              onClick={subItem.onClick}
              onKeyDown={subItem.onKeyDown}
              title={subItem.title || subItem.label}
            >
              <span>
                {subItem.icon && cloneElement(subItem.icon, { className: labelIconClassName }) }
                {subItem.label}
              </span>
            </MenuItem>
          ))}
        </div>
      </div>
    ))}
  </div>
);

DefaultMegaMenuRenderer.propTypes = {
  /** The set of items to be rendered in the menu */
  items: PropTypes.shape({
    /** The icon to be rendered next to the label */
    icon: renderableType,
    /** Text displayed when rendering the menu item */
    label: PropTypes.string,
    /** Text displayed on hover */
    title: PropTypes.string,
    /** Function executed when the menu item is clicked */
    onClick: PropTypes.func,
  }),
};
